/** 与 advisor-h5 同一命名空间 `advisor:<tenant>:<userId>`,同一用户两脸续同一后端会话。 */
export interface SessionIdentity {
  tenantCode: string | null;
  userId: number;
}

export function buildSessionId(id: SessionIdentity | null | undefined): string {
  if (!id || !id.tenantCode || id.userId == null) return "advisor:anon:0";
  return `advisor:${id.tenantCode}:${id.userId}`;
}
